import LbTable from '@/components/lb-table/lb-table'
import eldate from '@/components/eldate.vue'
import mixinsPrint from '@/pages/officeApproval/approvalList/mixins/printPdf.js'
// import printJS from 'print-js'
export default {
  mixins: [mixinsPrint],
  components: {
    LbTable,
    eldate
  },
  data() {
    return {
      tabsList: [
        {
          name: '全部',
          value: '0',
          count: 0
        },
        {
          name: '审批中',
          value: '1',
          count: 0
        },
        {
          name: '审批通过',
          value: '2',
          count: 0
        },
        {
          name: '驳回',
          value: '3',
          count: 0
        },
        {
          name: '已撤销',
          value: '4',
          count: 0
        }
      ],
      currentTab:'0',
      page: {
        pageNo: 1,
        pageSize: 10
      },
      loading: false,
      list: [],
      totalNum: 0,
      approvalNameList:[],
      processNameList:[],
      startUserLoading:false, // 发起人
      startStatus: "A", 
      startUserList:[],
      approverUserLoading:false,// 审批人
      approverStatus: "A",
      approverUserList:[],
    }
  },
  computed: {

  },
  created() {
    this.getTemplateNameList()
  },
  methods: {
    getTemplateNameList(){
      this.$api.workflowNameList().then(res=>{
        if(res.code == 0){
          this.processNameList = []
          this.approvalNameList = []
          res.data.forEach(e=>{
            if (e.isSystem) {
              this.processNameList.push(e.templateName)
            }else{
              this.approvalNameList.push({ id: String(e.id), templateName: e.templateName })
            }
          })
          this.resolveApprovalFormSelection()
        }
      })
    },
    resolveApprovalFormSelection(){
      if (!this.searchForm.approvalFormId && this.searchForm.approvalFormName) {
        const matches = this.approvalNameList.filter(item => item.templateName === this.searchForm.approvalFormName)
        if (matches.length === 1) {
          this.$set(this.searchForm, 'approvalFormId', matches[0].id)
          this.searchForm.approvalFormName = ''
        }
      }
    },
    changeSelect(type){
      if(type == 'approvalFormId'){
        this.searchForm.approvalFormName = ''
        this.searchForm.approvalFlowName = ''
      }else  if(type == 'approvalFlowName'){
        this.searchForm.approvalFormId = ''
        this.searchForm.approvalFormName = ''
      }
    },
    // 搜索员工
    searchUser(query,type){
      if (!query) return false
      const postData = {
        pageNo:1,
        pageSize:10,
        reallyName:query
      }
      if(type == 'approver'){
        this.approverUserLoading = true
        postData.status = this.approverStatus
      }else if(type == 'start'){
        this.startUserLoading = true
        postData.status = this.startStatus
      }
      // console.log('>>',postData)
      this.$api.workflowUserList(postData).then(res=>{
        if(res.code == 0){
          if(type == 'approver'){
            this.approverUserList = res.data
          }else if (type == 'start'){
            this.startUserList = res.data
          }
          
        }
      }).finally(() => {
        this.approverUserLoading = false;
        this.startUserLoading = false;
      });
    },
    handleClear(type){
      if(type == 'approver'){
        this.approverUserList = []
      }else if (type == 'start'){
        this.startUserList = []
      }
    },
    // 切换职状态
    changeStatus(type){
      if (type == 'approver') {
        this.approverUserList = []
        this.searchForm.approverUserId = ''
      }else if (type == 'start') {
        this.startUserList = []
        this.searchForm.startUserId = ''
      }
    },
    // 导出
    // deliverData() {
    //   return false
    //   if (this.searchForm.ids.length == 0) {
    //     this.$message.warning('请勾选导出的数据')
    //   } else {
    //     this.axios.post('/oa/sys/applicant/export', this.searchForm).then(res => {
    //       if (res.code == 0) {
    //         this.downloadlink(res.data)
    //         this.$message({
    //           type: 'success',
    //           message: '导出成功!'
    //         })
    //       }
    //     })
    //   }
    // },
    // downloadlink(url) {
    //   const iframe = document.createElement('iframe')
    //   iframe.style.display = 'none'
    //   iframe.src = url
    //   document.body.appendChild(iframe)
    // },
    // // 打印
    // alotPrint() {
    //   return false
    //   if (this.searchForm.ids.length == 0) {
    //     // if (this.selectIds.length == 0) {
    //     this.$message.error('请选择需要打印的简历')
    //   } else {
    //     // this.searchForm.ids = this.selectIds
    //     if (this.searchForm.allFlag == 1) {
    //       this.searchForm.ids = []
    //     }
    //     this.axios.post('/oa/sys/applicant/detail/list', this.searchForm).then((res) => {
    //       console.log(res)
    //       if (res.code == 0) {
    //         this.currentRow = res.data
    //         if (Array.isArray(this.currentRow) && this.currentRow.length > 0) {
    //           this.currentRow.forEach(e => {
    //             if (!e.trainingInfoList) {
    //               e.trainingInfoList = []
    //             }
    //           })
    //           setTimeout(() => {
    //             printJS({
    //               printable: 'print-content', // 需要打印的元素的ID
    //               type: 'html',
    //               documentTitle: '应聘明细',
    //               style: '@page { size: auto;  margin:8mm 5mm 4mm 4mm;},.page-break {page-break-after: always;},@media print {.person-info{display: flex} .person-left{width:320px;} .avatar{ width: 120px;height: 200px;margin-left:20px} .content{display:flex;justify-content:space-between;flex-wrap:wrap;}.item{display:flex;line-height:30px;min-width:50%} .person-right{flex:1} .title {font-weight: bold;}  .trhead td{text-align: center;} }',
    //               scanStyles: false
    //             });
    //           }, 1000)
    //         }

    //       } else {
    //         this.$message.error(res.message)
    //       }
    //     })
    //   }
    // },
    // getDetail(id) {
    //   this.selectIds = []
    //   this.selectIds.push(id)
    //   this.searchForm.ids = this.selectIds
    //   this.axios.post('/oa/sys/applicant/detail/list', this.searchForm).then((res) => {
    //     console.log(res)
    //     if (res.code == 0) {
    //       this.currentRow = res.data
    //       if (Array.isArray(this.currentRow) && this.currentRow.length > 0) {
    //         this.currentRow.forEach(e => {
    //           if (!e.trainingInfoList) {
    //             e.trainingInfoList = []
    //           }
    //         })
    //       }
    //     } else {
    //       this.$message.error(res.message)
    //     }
    //   })

    // },
    // print(row) {
    //   this.getDetail(row.id)
    //   setTimeout(() => {
    //     printJS({
    //       printable: 'print-content', // 需要打印的元素的ID
    //       type: 'html',
    //       documentTitle: '应聘明细',
    //       style: '@page { size: auto; margin:8mm 5mm 4mm 4mm;},.page-break {page-break-after: always;},@media print {.person-info{display: flex} .person-left{width:320px;} .avatar{ width: 120px;height: 200px;margin-left:20px} .content{display:flex;justify-content:space-between;flex-wrap:wrap;}.item{display:flex;line-height:30px;min-width:50%} .person-right{flex:1} .title {font-weight: bold;}  .trhead td{text-align: center;} }',
    //       scanStyles: false
    //     });
    //   }, 1000)
    // },
    fetchData(type,status) {
      if (type == 'reset') {
        let  initiationType = this.searchForm.initiationType
        this.searchForm = {}
        this.approverStatus = 'A'
        this.startStatus = 'A'
        if (this.$route.name == 'approvalManageList') {
          this.currentTab = '1'
        }else{
          this.currentTab = '0'
        }
        this.startTime = []
        this.endTime = []
        this.approverUserList = []
        this.startUserList = []
        this.searchForm.initiationType = initiationType
        this.page.pageNo = 1
      } else {
        if (this.startTime && this.startTime.length > 0) {
          this.searchForm.startTimeBegin = this.startTime[0]
          this.searchForm.startTimeEnd = this.startTime[1]
        } else {
          this.searchForm.startTimeBegin = ''
          this.searchForm.startTimeEnd = ''
        }
        if (this.endTime && this.endTime.length > 0) {
          this.searchForm.endTimeBegin = this.endTime[0]
          this.searchForm.endTimeEnd = this.endTime[1]
        } else {
          this.searchForm.endTimeBegin = ''
          this.searchForm.endTimeEnd = ''
        }
      }
      this.searchForm.pageNo = this.page.pageNo
      this.searchForm.pageSize = this.page.pageSize
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.page.pageNo = 1
      }
      // 我处理的页面特殊处理
      console.log('>>',this.$route.name)
      if (this.$route.name == 'approvalManageList') {
        this.searchForm.pendingStatus = this.currentTab
      } else {
        if (this.currentTab === '0') {
          this.searchForm.approvalStatus = ''
        }else{
          this.searchForm.approvalStatus = this.currentTab
        }
      }
      this.searchForm.ids = []
      // 查看数据的逻辑
      let name = this.$route.query.name
      if (name) {
        this.searchForm.name = name
      }
      this.resolveApprovalFormSelection()
      this.loading = true
      // 统计个数
      if(status !== 'noCount'){
        this.$api.workflowApplyStatistics(this.searchForm).then((res) => {
          console.log(res)
          if (res.code == 0) {
              const statistics = res.data || {}
              this.tabsList[0].count = statistics.total || 0
              this.tabsList[1].count = statistics.processing || 0
              this.tabsList[2].count = statistics.approved || 0
              this.tabsList[3].count = statistics.rejected || 0
              this.tabsList[4].count = statistics.withdrawn || 0
              // 我处理的页面特殊处理 待处理、已处理、全部
              if (this.$route.name == 'approvalManageList') {
                this.manageTabsList[0].count = statistics.pendingCount || 0
                this.manageTabsList[1].count = statistics.processedCount || 0
                this.manageTabsList[2].count = statistics.allCount || 0
              }
          } else {
              this.$message.error(res.message)
          }
        })
      }
      this.$api.workflowApplyList(this.searchForm).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.list = res.data.records || []
          this.totalNum = res.data.total
          // 没请求统计接口，这里需要更新当前统计
          // console.log('>>',status,this.searchForm.approvalStatus)
          if(status === 'noCount'){
            let index = this.searchForm.approvalStatus || 0
            this.tabsList[index].count = this.totalNum
          }
        } else {
          this.list = []
          this.totalNum = 0
          this.$message.error(res.message)
        }
        this.loading = false
      }).catch(err=>{
        this.list = []
        this.totalNum = 0
        this.loading = false
      })
    },

   
    onMultipleSelection(val) {
      if (val) {
        this.searchForm.ids = val.map((item) => {
          return item.processInstanceId
        })
      }

    },
    handleCurrentChange(e) {
      this.page.pageNo = e
      this.fetchData()
    },
    handleSizeChange(e) {
      this.page.pageSize = e
      this.fetchData()
    },
    changeData(val, type) {
      console.log(val)
      if (type == 'startTime') {
          this.startTime = val
      } else {
          this.endTime = val
      }
    },
    rowContent(str){
      let obj
      try {
        obj = JSON.parse(str)
        if(typeof obj === 'object'){
          // console.log('>>',obj)
          return this.objToString(obj)
        }else{
          // console.log('>>',str)
          return str
        }
      } catch (error) {
        // console.log('error：',str)
        // 无法转成对象的是数组
        if(str.includes('[')){
          return this.ArrayToString(this.parseStringToArray(str))
        }else{
          return str
        }
      }
  
    },
    // 对象处理 地址、手机
    objToString(obj){
      let res
      if(obj.inputType === 'detail'){
        // console.log('detail>>',obj)
        res = obj.value.join('') + obj.detail
      }else if(obj.inputType === 'city' || obj.inputType === 'area'){
        res = obj.value.join('')
      }else if(obj.inputType === 'phone'){
        res = '手机'+ obj.value
      }else if(obj.inputType === 'tel'){
        res = '固话'+ obj.value
      }
      return res
    },
    // 数组处理
    ArrayToString(array){
      
      let res
      if (typeof array[0] === 'string') {
        res = array.join('、')
      }else{
        if(array[0].name){
          let nameArray = array.map(item => item.name)
          res = nameArray.join('、')
        }
      }
      return res
    },
    // 处理字符串
    parseStringToArray(input) {
      // 去除外层的方括号
      const trimmedInput = input.trim().slice(1, -1);
    
      // 检查是否包含逗号分隔的对象
      if (trimmedInput.includes('{') && trimmedInput.includes('}')) {
        // 处理对象数组
        const objectPattern = /\{([^}]*)\}/g;
        const matches = trimmedInput.match(objectPattern);
    
        if (!matches) {
          return [];
        }
    
        return matches.map(match => {
          // 去除外层的花括号
          const innerTrimmed = match.slice(1, -1);
          // 使用正则表达式匹配键值对
          const keyValuePairs = innerTrimmed.match(/([^=,]+)\s*=\s*('[^']*'|"[^"]*"|[^,}]+)/g);
    
          if (!keyValuePairs) {
            return {};
          }
    
          // 创建对象
          const obj = {};
          keyValuePairs.forEach(pair => {
            const [key, value] = pair.split('=').map(item => item.trim());
            // 去除引号
            let cleanedValue = value.replace(/^['"]|['"]$/g, '');
            // 将布尔值字符串转换为布尔值
            if (cleanedValue === 'true') {
              obj[key] = true;
            } else if (cleanedValue === 'false') {
              obj[key] = false;
            } else if (!isNaN(cleanedValue)) {
              obj[key] = Number(cleanedValue);
            } else {
              obj[key] = cleanedValue;
            }
          });
    
          return obj;
        });
      } else {
        // 处理简单字符串数组
        return trimmedInput.split(',').map(item => item.trim().replace(/^['"]|['"]$/g, ''));
      }
    },
    parseContent(content){
      if(Array.isArray(content)){
        return content.map(item => item.goodsName || '').filter(Boolean).join(',');
      }

      if(typeof content === 'string') {
        // 处理字符串格式的数组
        if (content.startsWith('[') && content.includes('goodsName')) {
          try {
              // 方法1：尝试直接解析 （如果是标准json）
              const parsed = JSON.parse(content);
              if (Array.isArray(parsed)) {
                return parsed.map(item => item.goodsName || '').filter(Boolean).join(',');
              }
          } catch (e) {
            // 方法2：处理非标准格式"[{goodsName=值,...}]"
            const matches = content.match(/goodsName=([^,]*)/g);
            if (matches) {
              return matches.map(match => match.replace('goodsName=','')).join(',');
            }
          }
        }
        return this.rowContent(content)
      }
      return string(content)
    }
  }
}
